import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import Scrollbar from 'react-scrollbars-custom';
import { withStyles } from '@material-ui/core/styles';
import { withWidth, Grid, Switch } from '@material-ui/core';
import last from 'lodash/last';

import ReactTippyWrapper from '../ReactTippyWrapper';
import LikeIcon from '../LikeIcon';
import VCLightbox from '../VCLightbox';
import TimeAgo from '../TimeAgo';
import LikeListContainer from '../../containers/LikeListContainer';
import VCProfile from '../../containers/VCProfile';
import { getActivityLikes } from '../../utils/vcUtils';

import add from '../../assets/images/reply-paint.svg';
import './index.scss';
import styles from './styles';

class VcCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLightboxOpen: false,
      lightboxIndex: 0,
    };
    this.onLightboxNext = this.onLightboxNext.bind(this);
    this.onLightboxPrevious = this.onLightboxPrevious.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.closeLightbox = this.closeLightbox.bind(this);
    this.disable = this.disable.bind(this);
    this.slider = React.createRef();
    this.singleSliderContainer = React.createRef();
  }

  componentDidMount() {
    const { isAuthenticated, level } = this.props;
    if (isAuthenticated && level >= 2) {
      this.slider.scrollToRight();
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedId, data } = this.props;
    const { selectedId: prevSelectedId } = prevProps;
    if (selectedId !== prevSelectedId) {
      const index = data.findIndex(elem => elem.id === selectedId);
      const slideWidth = this.singleSliderContainer.current.clientWidth;
      this.slider.scrollLeft = slideWidth * index;
    }
  }

  onLightboxNext() {
    const { lightboxIndex } = this.state;
    this.setState({ lightboxIndex: lightboxIndex + 1 });
  }

  onLightboxPrevious() {
    const { lightboxIndex } = this.state;
    this.setState({ lightboxIndex: lightboxIndex - 1 });
  }

  closeLightbox(index) {
    this.setState({ isLightboxOpen: false, lightboxIndex: 0 });
  }

  disable(user_can_reply, givenLevel) {
    const { isAuthenticated, level } = this.props;
    return !isAuthenticated || givenLevel > level || !user_can_reply;
  }

  openLightbox(index) {
    this.setState({ isLightboxOpen: true, lightboxIndex: index });
  }

  render() {
    const {
      isVisible, data, onLikeActivity, isLikeRequestInitiated, isCurationRequestInitiated, onCurationActivity,
      isCurator, isAuthenticated, openDrawingTool, vcId, level, classes, authFollowAction,
    } = this.props;
    const {
      lightboxIndex, isLightboxOpen,
    } = this.state;
    const slides = data;
    const lastSlide = last(slides);
    return (
      <div className="feedCarouselWrapper">
        {isLightboxOpen && (
          <div className="lightboxImage">
            <VCLightbox
              isOpen={isLightboxOpen}
              currentIndex={lightboxIndex}
              onClose={this.closeLightbox}
              dataSet={slides}
              onNext={this.onLightboxNext}
              onPrev={this.onLightboxPrevious}
              onLikeActivity={onLikeActivity}
              disable={this.disable}
              openDrawingTool={openDrawingTool}
              userLevel={level}
              vcId={vcId}
              authFollowAction={authFollowAction}
            />
          </div>
        )
        }
        <Scrollbar
          style={{ width: '100%' }}
          className="scrollContainer carouselScrollHorizontalTrack"
          ref={(ref) => { this.slider = ref; }}
        >
          <Grid container direction="row" wrap="nowrap">

            {
              slides.map((elem, index) => (
                <Grid item key={elem.id}>
                  <div className="slideContainer" ref={this.singleSliderContainer}>
                    {isVisible && (
                      <div>
                        <div
                          style={{ backgroundImage: `url(${elem.src})` }}
                          role="button"
                          onClick={() => this.openLightbox(index)}
                          className="sliderImage"
                          tabIndex={0}
                        />
                        <div>
                          <Grid className="likeArtWrap" container direction="row" justify="space-between">
                            <Grid item>
                              <VCProfile id={elem.ownerId} authFollowAction={authFollowAction} vcId={vcId} />
                            </Grid>
                            <Grid>
                              <div className="interactions">
                                <div className="dFlex">
                                  { isAuthenticated && isCurator && (
                                    <Switch
                                      checked={elem.curated_by_user}
                                      disabled={isCurationRequestInitiated}
                                      onChange={() => onCurationActivity(elem.id)}
                                      classes={{
                                        root: classes.root,
                                        switchBase: classes.iOSSwitchBase,
                                        bar: classes.iOSBar,
                                        icon: classes.iOSIcon,
                                        iconChecked: classes.iOSIconChecked,
                                        checked: classes.iOSChecked,
                                      }}
                                    />
                                  ) }
                                  <button
                                    type="button"
                                    onClick={() => onLikeActivity(elem.id, elem.likes_count, elem.parentIdsTrail)}
                                    disabled={isLikeRequestInitiated}
                                    className="likeButton"
                                  >
                                    <LikeIcon liked={elem.liked_by_user} />
                                    <LikeListContainer
                                      identifier={elem.id}
                                      count={elem.likes_count}
                                      dataFetcher={getActivityLikes}
                                    />
                                  </button>
                                  <ReactTippyWrapper
                                    title={!this.disable(elem.user_can_reply, slides[0].level) ? ' '
                                      : 'All 4 replies have filled for this drawing'}
                                    position="bottom"
                                    theme="transparent"
                                  >
                                    {(level === 1 || !level) ? null : (
                                      <button
                                        type="button"
                                        disabled={this.disable(elem.user_can_reply, slides[0].level)}
                                        onClick={() => { openDrawingTool(true, elem.id, vcId, elem.title); }}
                                      >
                                        <img className="replyBtn" src={add} alt="" />
                                      </button>
                                    )}
                                  </ReactTippyWrapper>
                                </div>
                                <p className="duration"><TimeAgo datetime={elem.created_at} /></p>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    )
                    }
                  </div>
                </Grid>
              ))}
            <div className="singleSlideItem">
              <div className="slideContainer">
                {isVisible
                  && (
                    <Grid container alignContent="center" alignItems="center" className="replySlideWrapper">
                      <ReactTippyWrapper
                        title={!this.disable(lastSlide.user_can_reply, lastSlide.level) ? ' '
                          : 'All 4 replies have filled for this drawing'}
                        position="bottom"
                      >
                        <Grid item>
                          <button
                            type="button"
                            style={{ backgroundImage: `url(${add})`, border: 'none' }}
                            className="sliderImage replySlide"
                            disabled={this.disable(lastSlide.user_can_reply, slides[0].level)}
                            onClick={() => {
                              openDrawingTool(true, lastSlide.id, vcId,
                                lastSlide.title);
                            }}
                          />
                        </Grid>
                      </ReactTippyWrapper>
                    </Grid>
                  )
                }
              </div>
            </div>
          </Grid>
        </Scrollbar>
      </div>
    );
  }
}

VcCarousel.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  isVisible: PropTypes.bool,
  isAuthenticated: PropTypes.bool.isRequired,
  onLikeActivity: PropTypes.func.isRequired,
  isLikeRequestInitiated: PropTypes.bool.isRequired,
  selectedId: PropTypes.number,
  level: PropTypes.number,
  authFollowAction: PropTypes.string.isRequired,
};

VcCarousel.defaultProps = {
  selectedId: null,
  isVisible: false,
  level: null,
};

// withWidth is used so that props trigger when width changes.
export default withStyles(styles)(withWidth()(VcCarousel));



// WEBPACK FOOTER //
// ./src/components/FeedCarousel/index.js